import type {Post} from '@mattermost/types/posts';
import {getConfig} from 'mattermost-redux/selectors/entities/general';
import {fromAutoResponder, getImageSrc, isFromWebhook} from 'utils/post_utils';
import Constants from 'utils/constants';
import {type GlobalState} from 'types/store';

export function getPostOverrideIconURL(state: GlobalState, post?: Post) {
    if (!post || !isFromWebhook(post) || fromAutoResponder(post)) {
        return;
    }

    const config = getConfig(state);
    const hasImageProxy = config.HasImageProxy === 'true';
    const additionalSiteURLs = config.AdditionalSiteURLs;
    const iconUrl = config.EnablePostIconOverride === 'true' ? post.props?.override_icon_url : undefined;

    return iconUrl ? getImageSrc(iconUrl, hasImageProxy, additionalSiteURLs) : Constants.DEFAULT_WEBHOOK_LOGO as string;
}
